import React, { useEffect, useState, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import './style.less'

const NProgress: React.FC = () => {
  const location = useLocation()
  const [progress, setProgress] = useState(0)
  const [visible, setVisible] = useState(false)
  const timer = useRef<ReturnType<typeof setTimeout>>()

  useEffect(() => {
    setVisible(true)
    setProgress(30)

    timer.current = setTimeout(() => setProgress(70), 100)

    const done = setTimeout(() => {
      setProgress(100)
      setTimeout(() => {
        setVisible(false)
        setProgress(0)
      }, 200)
    }, 300)

    return () => {
      clearTimeout(timer.current)
      clearTimeout(done)
    }
  }, [location.pathname])

  if (!visible && progress === 0) return null

  return (
    <div className="nprogress-bar" style={{ transform: `scaleX(${progress / 100})`, opacity: progress >= 100 ? 0 : 1 }} />
  )
}

export default NProgress
